import address from "address";
import { resolve } from "any-promise";
import init_idb from './init_idb'
import idb_di from './done_items'

const DB_NAME = 'ckb';
const DB_VERSION = 117; // Use a long long for this value (don't use a float)
const DB_STORE_NAME = 'executions';

function openIndexedDB () {
  // This works on all devices/browsers, and uses IndexedDBShim as a final fallback 
  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
  var openDB = indexedDB.open(DB_NAME, DB_VERSION);

  openDB.onsuccess = function(event) {
    // store the result of opening the database in the db variable.
    db = openDB.result
    // console.log("Database opened.")
    // console.log(`Database version: ${db.version}`)
  
    // add listener to handle the database version change
    db.onversionchange = function() {
      // console.log("Database is outdated, please reload the page.")
  
      //!important when version change is detected close the database immediately
      db.close()
      // instruct the user to reload the page via popup
      // and block any interaction with the site
      // launchPopup($newVersionPopupContent)
      alert("Database is outdated, please reload the page.")
      window.location.reload()
    }
  }

  // console.log('DB OPENED', openDB);
  openDB.onupgradeneeded = function(event) {
    init_idb(event)
  };

  openDB.onerror = function(error){
    console.log("Erro open db: ", error)
  }

  return openDB;
}

function getStoreIndexedDB (openDB, mode) {
  var db = {};
  db.result = openDB.result;
  db.tx = db.result.transaction(DB_STORE_NAME, mode);
  db.thisStore = db.tx.objectStore(DB_STORE_NAME);

  return db;
}

export default{
  store_executions(one_execution){  
    // console.log({one_execution});
    return new Promise(resolve =>{
      var openDB = openIndexedDB();

      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readwrite');

        var addRequest = db.thisStore.add(one_execution);

        addRequest.onsuccess = function(){
          // console.log("Execution armazenado")
          resolve(true)
        }
        addRequest.onerror = function(error){
          // console.log("idb Erro ao tentar armazenar execution", error)
          resolve(false)
        }
        // var addRequest = db.thisStore.add({allExecutions});
        // for(let i = 0; i < allExecutions.length ; i++) {
          // var addRequest = db.thisStore.add(allExecutions[i]);
          // console.log({addRequest});
        // };
        // db.tx.oncomplete = function(){
          // // console.log("CustomFields armazenadas para uso offline")
          // resolve(true)
        // }
        // db.tx.onerror = function(error){
          // console.log("idb Erro ao tentar armazenar as executions", error)
          // resolve(false)
        // }
        
      }
      
      
    })

    
  },

  clear_all_executions() {
    return new Promise(resolve => {
      //    // auto-comment// console.log('start clear');
      
      var openDB = openIndexedDB();
  
      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readwrite');
  
        var clearRequest = db.thisStore.clear();
  
        clearRequest.onsuccess = function() {
             // auto-comment// console.log("CustomFields foram apagadas do store");
          resolve(true)
        }
        clearRequest.onerror = function(error){
             // auto-comment// console.log("nao foi possível limpar o store de executions", error)
          resolve(false)
        }
      }
      
    })
    
  },

  get_executions({key = 'solution_id', by_id}){
    return new Promise(resolve => {
      var executions = [];

      var openDB = openIndexedDB();
  
      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readonly');

        let the_index = db.thisStore.index(key);
        let exec_done_items = the_index.openCursor(IDBKeyRange.only(by_id)); 
  
        exec_done_items.onsuccess = function(event) {
          var cursor = event.target.result;
          if (cursor) {
            // console.log({cursor});
            executions.push(cursor.value);
            cursor.continue();
          }else{
               // auto-comment// console.log("estas sao as executions salvas: ", executions[0])
            resolve(executions)
          }
        };
        
      }      
      
    })
  },

  
  get_one_execution(id){
    return new Promise((resolve, reject) => {
      var execution = {};

      var openDB = openIndexedDB();
  
      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readonly');

        // var transaction = db.transaction(['contactsList'], 'readonly');
        // var objectStore = transaction.objectStore('contactsList');

        var myIndex = db.thisStore.index('idb_id');
        var getRequest = myIndex.get(id);
        getRequest.onsuccess = function(event) {
          var cursor = event.target.result;
          // console.log(getRequest.result);
          // console.log(cursor);
          if (cursor) {
            execution = {...cursor};
            resolve(execution)
          }else{
            resolve(null)
            //reject(`Execution with id "${id}" not found`)
            
            // throw Error(`CustomField with id "${id}" not found`)
          }
        }
      }    
      
    })
  },

  gen_exec_three_first_answers(up_exec_id){
    return new Promise(async(resolve, reject) => {
      // console.log('gerar exec 3 first answers');
      var execution = await this.get_one_execution(up_exec_id)

      let done_items = await idb_di.get_done_items('execution_idb_id' , up_exec_id)
      done_items = done_items.filter(di => di.item_index < 3)
      done_items = done_items.sort(function(a, b){
        return a.item_index == b.item_index ? 0 : +(a.item_index > b.item_index) || -1;
      })
      done_items = done_items.map(di => {return [di.title, di.answer]})
      // console.log({done_items});
      
      execution = {
        ...execution,
        // idb_id: up_exec_id,
        first_three_answers: done_items
      }

      var openDB = openIndexedDB();
  
      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readwrite');

        // var transaction = db.transaction(['contactsList'], 'readonly');
        // var objectStore = transaction.objectStore('contactsList');

        var myIndex = db.thisStore.index('idb_id');
        // console.log({execution});
        var putRequest = db.thisStore.put(execution);
        putRequest.onsuccess = function(event) {
          var cursor = event.target.result;
          // console.log(putRequest.result);
          // console.log(cursor);
          if (cursor) {
            execution = {...cursor};
            resolve(execution)
          }else{
            reject(`Execution with id "${execution.idb_id}" not found`)
            // throw Error(`CustomField with id "${id}" not found`)
          }
        }
        putRequest.onerror = function(e){
          // console.log('Error adding: ', e);
          reject(`Execution with id "${up_exec.idb_id}" error: ${e}`)
        };
      }    
      
    })
  },

  update_one_execution(up_exec){
    return new Promise((resolve, reject) => {
      var execution = {};

      var openDB = openIndexedDB();
  
      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readwrite');

        // var transaction = db.transaction(['contactsList'], 'readonly');
        // var objectStore = transaction.objectStore('contactsList');

        var myIndex = db.thisStore.index('idb_id');
        // console.log(up_exec);
        var putRequest = db.thisStore.put(up_exec);
        putRequest.onsuccess = function(event) {
          var cursor = event.target.result;
          // console.log(putRequest.result);
          // console.log(cursor);
          if (cursor) {
            execution = {...cursor};
            resolve(execution)
          }else{
            reject(`Execution with id "${up_exec.idb_id}" not found`)
            // throw Error(`CustomField with id "${id}" not found`)
          }
        }
        putRequest.onerror = function(e){
          // console.log('Error adding: ', e);
          reject(`Execution with id "${up_exec.idb_id}" error: ${e}`)
        };
      }    
      
    })
  },


  delete_executions(key = 'done_form_id', by_id){
    return new Promise(resolve => {
      let deleted = []

      var openDB = openIndexedDB();

      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readwrite');

        let the_index = db.thisStore.index(key);
        let to_destroy = the_index.openKeyCursor(IDBKeyRange.only(by_id)); 
        // console.log({key});
        // console.log({by_id});
        // console.log({the_index});
        // console.log({to_destroy});

        to_destroy.onsuccess = function() {
          var cursor = to_destroy.result;
          if (cursor) {
            deleted.push(cursor.primaryKey)
            db.thisStore.delete(cursor.primaryKey);
            // console.log({deleted});

            cursor.continue();
          }else{
            // auto-comment// console.log("estas sao as executions salvas: ", executions[0])
            resolve(deleted)
          }
        }
        
      }      
      
    })
  },
}
